import React, { Component } from 'react';
import './style.css';
import {Link} from 'react-router-dom';
import Icon from 'react-icons-kit';
import {androidDelete} from 'react-icons-kit/ionicons/androidDelete';
import {edit} from 'react-icons-kit/ionicons/edit';

class DemographicsSecondSubQuestionList extends Component {
  constructor(props){
    super(props)
    this.state={
    };
   
  }

  addSecSubQuestion(){
      this.props.addSecSubQuestion();
  }

  softDeleteSecSubQuestion(data){
    this.props.softDeleteSecSubQuestion(data);
  }

  backtoPage(){
    window.history.back();
  }

  editSecSubQuestion(data){
    this.props.editSecSubQuestion(data);
  }

  render(){
    
    let subQuestionDataList = "";
    if(this.props.demoGraphicsSecSubQuesOptionsListSuccess){
      
    if(this.props.demoGraphicsSecSubQuesOptionsListData && this.props.demoGraphicsSecSubQuesOptionsListData.length > 0){
        let subQuestions = this.props.demoGraphicsSecSubQuesOptionsListData;
        subQuestionDataList = Object.keys(subQuestions).map((item, index) => {
        let subQuestionItem = subQuestions[item];

      

        return <tr key={index} >
            <td style ={{ textAlign : "center" }} >{index+1}</td>
            <td style ={{ textAlign : "center" }} >{subQuestionItem.questions}</td>
            <td style ={{ textAlign : "center" }} >{subQuestionItem.selectionType}</td>
            <td style ={{ textAlign : "center" }} >{subQuestionItem.orderSecondSubQues}</td>
        
            <td className = "cat_action">
            
            <button onClick = {this.editSecSubQuestion.bind(this, subQuestionItem)} className = "removebutton">
            < Icon icon={edit} size={30} style={{ color: '#336699' }}/>
            </button>
            <button onClick = {this.softDeleteSecSubQuestion.bind(this, subQuestionItem)} className = "removebutton">< Icon icon={androidDelete} size={30} style={{ color: '#EF233C' }}/></button>            
            </td>
          </tr>
          });
    }else{
        subQuestionDataList = "No data"
    }
  }

  return (<div className = "userlist">
  <div className = "userlistbackground">
        <div className = "usertable"><h1>Second Sub Question List</h1></div>
     <button className = "goBackBySubQuestion"   onClick={this.backtoPage.bind(this)}>Back</button>
     <button  className = "addSubQuestionbtn" onClick={this.addSecSubQuestion.bind(this)}>Add Second Sub Question</button>
        <div className = "autoscroll">
        <table className = "demoategoryTable">
          <thead>
            <tr >
              <th>Sr.No.</th>
              <th>Question</th>
              <th>SelectionType</th>
              <th>Order No.</th>
              <th>Action</th> 
            </tr>
          </thead>
            <tbody> 
              {subQuestionDataList}  
            </tbody>
        </table>
        </div>
        </div>
        </div>
        
    );
  }
}
export default DemographicsSecondSubQuestionList;



// WEBPACK FOOTER //
// ./src/components/demographics/secSubQuestionList.js